<template>
  <p class="mb-0 f-16 sz-primary-grey--text font-weight-regular pre-line">
    {{ trimmedText.trim() }}
    <span v-if="visible" class="primary-link f-16 font-weight-medium pointer" @click="showMore">
      {{ $t('label.readMore') }}
    </span>
  </p>
</template>

<script>
export default {
  name: 'ReadMoreText',
  props: {
    text: {
      required: true,
      type: String
    }
  },
  data() {
    return {
      show: false,
      visible: false,
      endIndex: 350,
      offsetIndex: 0
    }
  },
  computed: {
    trimmedText() {
      if (this.visible && this.show === false) {
        return this.text.substr(0, this.endIndex + this.offsetIndex)
      }
      return this.text
    }
  },
  created() {
    this.offsetIndex = this.text.substring(this.endIndex).indexOf('.')
    this.offsetIndex =
      this.offsetIndex === -1
        ? this.text.substring(this.endIndex).indexOf('?') + 1
        : this.offsetIndex + 1

    this.visible = this.text.length > this.endIndex + this.offsetIndex
  },
  methods: {
    showMore() {
      this.visible = !this.visible
      this.show = !this.show
    }
  }
}
</script>
